import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { MainLayout } from "../components/Layout/MainLayout";
import { MainPage } from "../features/main/components/mainPage";
import { SingleProduct } from "../features/product/components/singeProduct";
import SingleCategoryPage from "../features/categorys/components/singleCategory";
import CartPage from "../features/cart/components/CartPage";
import RegisterPage from "../features/register/components/RegisterPage";
import SingleUserProfile from "../features/user/components/SingleUserProfile";
import LoginPage from "../features/register/components/LoginPage";
import AuthLayout from "../features/register/components/AuthLayout";

// Layout Wrapper for Main App Layout
const LayoutWrapper = ({ children }: { children: React.ReactNode }) => (
  <MainLayout>{children}</MainLayout>
);

// App Component that wraps everything including AuthLayout
const App = () => (
  <LayoutWrapper>
    <Outlet />
  </LayoutWrapper>
);

// Public Routes with Auth Routes inside App and AuthLayout
const publicRoutes = [
  {
    path: "/home",
    element: <App />,
    children: [
      { index: true, element: <MainPage /> }, // Default `/home`
      { path: ":id", element: <SingleCategoryPage /> }, // Dynamic `/home/:id`
      { path: ":id/:productId", element: <SingleProduct /> }, // Dynamic `/home/:id/:productId`
    ],
  },
  {
    path: "/cart",
    element: <App />,
    children: [
      { index: true, element: <CartPage /> }, // Default `/cart`
    ],
  },

  {
    path: "/register", // /auth route wrapped inside App
    element: <App />,
    children: [
      {
        path: "", // Empty path for /auth will render AuthLayout
        element: <AuthLayout />,
        children: [
          { path: "", element: <RegisterPage /> }, // Register page route
          { path: "login", element: <LoginPage /> }, // Login page route
        ],
      },
    ],
  },
  {
    path: "*", // Redirect all other routes to `/home`
    element: <Navigate to="/home" replace />,
  },
];

export { publicRoutes };
